// ======================================================================
// File Name       : container
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/container';

export function receiveCourseStructure(structureList, userCourseRelation={}, groupCourseRelationList=[]) {
  return {
    type: ActionTypes.CONTAINER_RECEIVE_COURSE_STRUCTURE,
    structureList,
    userCourseRelation,
    groupCourseRelationList,
  };
}

export function initDataForEditStructureDialog(structureSecernId, structureSecernIdList, structureType) {
  return {
    type: ActionTypes.CONTAINER_INIT_DATA_FOR_EDIT_STRUCTURE,
    structureSecernId,
    structureSecernIdList,
    structureType,
  };
}

export function updateDisplayOrder(structureSecernIdList) {
  return {
    type: ActionTypes.CONTAINER_UPDATE_DISPLAY_ORDER,
    structureSecernIdList,
  };
}

export function reInitContainerTree(structures) {
  return {
    type: ActionTypes.CONTAINER_REINIT_CONTAINER_TREE,
    structures,
  };
}

export function destroyCourseTree() {
  return {
    type: ActionTypes.CONTAINER_DESTROY_CONTAINER_TREE,
  };
}

export function receiveInitTreeResult(isInitiated) {
  return {
    type: ActionTypes.CONTAINER_INIT_CONTAINER_TREE,
    isInitiated,
  };
}

// sprint_20230522_tma START
export function receiveCourseStructureItemTree(structureListItemTree) {
  return {
    type: ActionTypes.CONTAINER_RECEIVE_COURSE_STRUCTURE_ITEM_TREE,
    structureListItemTree,
  };
}

export function doSelectedItemOnDialog(selectedItemOnDialog) {
  return {
    type: ActionTypes.CONTAINER_SELECTED_ITEM_ON_DIALOG,
    selectedItemOnDialog,
  };
}

export function removeItemListRelation(index) {
  return {
    type: ActionTypes.CONTAINER_DEL_SELECTED_ITEM_ON_DIALOG,
    index,
  };
}

export function initDataForItemTreeDialog(structureSecernId, structureType, isRegister) {
  return {
    type: ActionTypes.CONTAINER_INIT_DATA_FOR_ITEM_TREE_DIALOG,
    structureSecernId,
    structureType,
    isRegister,
  };
}
// sprint_20230522_tma END
